
import React from 'react';

import { BrowserRouter, Route } from 'react-router-dom';

import MainPage from '../MainPage/MainPage';
import InfoView from '../InfoView/InfoView';
import DataView from '../DataView/DataView';

export default function MainRouter()
{
  return (
    <BrowserRouter basename="/test_react_02">
      <Route exact path="/"><MainPage /></Route>
      <Route exact path="/info"><InfoView /></Route>
      <Route exact path="/data"><DataView /></Route>
    </BrowserRouter>
  );
}